import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";

import RewardList from "@/modules/recognition/user/components/RewardList";
import { fetchRewardsQueryOptions } from "@/modules/recognition/user/services";

export const Route = createFileRoute(
  "/_panel/_recognition/recognition/rewards/",
)({
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Rewards", { ns: "recognition.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchRewardsQueryOptions()),
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("recognition.user");
  return (
    <Container
      title={t("Rewards", { ns: "recognition.shared" })}
      description={t(
        "With the points you have earned from appreciating your colleagues, you can here get rewards.",
      )}
      className="flex h-full flex-col"
    >
      <RewardList />
    </Container>
  );
}
